const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#42397b',
                hover: '#352c6c'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
